<iframe width="100%" height="100%" [src]="safeUrl" frameborder="0">
</iframe>
